const SLOTS_SELECTOR = "[data-slot]";
const SLOTS_BTN_SELECTOR = ".js-slots__btn";
const SLOTS_NAME_SELECTOR = ".js-slots__name";
const SLOTS_ITEM_SELECTOR = "[data-slot-item]";

const MODAL_SELECTOR = ".js-modal";
const MODAL_TITLE_SELECTOR = ".modal__title";
const IFRAME_SELECTOR = "iframe";

const ACTIVE_CLASS = "active";

export const initSlots = () => {
    const slotsWraps = document.querySelectorAll(SLOTS_SELECTOR);
    slotsWraps.forEach((wrap) => initSlotsElement(wrap));
}

const initSlotsElement = (wrap) => {

    // Modal elements
    const modal = document.querySelector(MODAL_SELECTOR);
    const modalTitle = modal?.querySelector(MODAL_TITLE_SELECTOR);
    const iframeEl = modal?.querySelector(IFRAME_SELECTOR);

    if (!modal) return;

    const slotsBtns = wrap?.querySelectorAll(SLOTS_BTN_SELECTOR);

    slotsBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const item = btn.closest(SLOTS_ITEM_SELECTOR);

            if(!item) return;

            const name = item.querySelector(SLOTS_NAME_SELECTOR)?.textContent;

            const url = btn.dataset.url;

            modalTitle && name ? modalTitle.textContent = name : null;
            iframeEl && url ? iframeEl.src = url : null;

            console.log(iframeEl, url)

            modal.classList.add(ACTIVE_CLASS);
        });
    });
};

initSlots();
